import * as angular from 'angular';
import * as _ from 'lodash';

import { Dispatcher, Store } from '../Store';
import * as ACTIONS from './onlineUsers.constants';
import { OnlineUserDto } from '../../models';
import { IUserService } from '../../services';

export interface IOnlineUserActionsService {
    getAll(): Dispatcher<OnlineUserDto[]>;
    updateOne(user: OnlineUserDto, isRemove: boolean): Dispatcher<OnlineUserDto[]>;
}

export class OnlineUserActionsService implements IOnlineUserActionsService {

    static serviceId = 'onlineUserActionsService';
    static $inject = ['$q', 'userService'];


    constructor(
        private _$q: angular.IQService,
        private _userService: IUserService
    ) {
    }

    getAll() {
        return (dispatch: any, getState: () => Store) => {
            const { onlineUsers } = getState();

            dispatch({ type: ACTIONS.ONLINE_USERS_LOAD, payload: onlineUsers });
            return this._userService
                .getOnlineUsers()
                .then(data => {
                    dispatch({ type: ACTIONS.ONLINE_USERS_LOAD_SUCCESS, payload: data });
                    return data;
                })
                .catch(reason => {
                    dispatch({ type: ACTIONS.ONLINE_USERS_LOAD_ERROR, payload: reason });
                    return reason;
                });
        };
    }

    updateOne(user: OnlineUserDto, isRemove: boolean) {
        return (dispatch: any, getState: () => Store) => {
            if (user) {
                const type = isRemove
                    ? ACTIONS.ONLINE_USER_REMOVE
                    : ACTIONS.ONLINE_USER_UPDATE;
                dispatch({ type, payload: user });
            }
            return this._$q.when(_.values<OnlineUserDto>(getState().onlineUsers.dictionary));
        };
    }
}